// Étincelles suggérées « vivantes » : varient selon la langue ET l'heure,
// puis sont mélangées pour surprendre à chaque inscription.

const POOLS = {
  fr: {
    base: [
      "Pourquoi le ciel est-il bleu ?", "Comment les abeilles fabriquent le miel",
      "Qu'y a-t-il au fond des océans ?", "D'où viennent les étoiles filantes ?",
      "Pourquoi la mer est-elle salée ?", "Comment fonctionne la mémoire ?",
      "Pourquoi les chats ronronnent-ils ?", "Comment naissent les volcans ?",
      "Pourquoi rit-on ?", "Comment les plantes se parlent-elles ?",
      "Pourquoi le temps semble parfois filer ?", "Comment les oiseaux trouvent leur chemin ?",
    ],
    morning: ["Pourquoi les oiseaux chantent-ils à l'aube ?", "Que se passe-t-il dans le cerveau au réveil ?", "Pourquoi le café nous réveille-t-il ?"],
    day: ["Pourquoi l'ombre change-t-elle de taille ?", "Comment les nuages tiennent-ils dans le ciel ?", "Pourquoi la faim se fait-elle sentir ?"],
    evening: ["Pourquoi le ciel rougit au coucher du soleil ?", "Comment les animaux se préparent à la nuit ?", "Pourquoi bâille-t-on le soir ?"],
    night: ["Pourquoi rêve-t-on la nuit ?", "Comment naissent et meurent les étoiles", "Pourquoi la Lune change-t-elle de forme ?", "Que voit-on vraiment dans la Voie lactée ?"],
  },
  en: {
    base: [
      "Why is the sky blue?", "How do bees make honey?",
      "What lies at the bottom of the oceans?", "Where do shooting stars come from?",
      "Why is the sea salty?", "How does memory work?",
      "Why do cats purr?", "How are volcanoes born?",
      "Why do we laugh?", "How do plants talk to each other?",
      "Why does time sometimes seem to fly?", "How do birds find their way?",
    ],
    morning: ["Why do birds sing at dawn?", "What happens in the brain when we wake up?", "Why does coffee wake us up?"],
    day: ["Why do shadows change size?", "How do clouds stay up in the sky?", "Why do we feel hungry?"],
    evening: ["Why does the sky turn red at sunset?", "How do animals get ready for the night?", "Why do we yawn in the evening?"],
    night: ["Why do we dream at night?", "How are stars born and how do they die?", "Why does the Moon change shape?", "What do we really see in the Milky Way?"],
  },
  es: {
    base: [
      "¿Por qué el cielo es azul?", "¿Cómo fabrican la miel las abejas?",
      "¿Qué hay en el fondo de los océanos?", "¿De dónde vienen las estrellas fugaces?",
      "¿Por qué el mar es salado?", "¿Cómo funciona la memoria?",
      "¿Por qué ronronean los gatos?", "¿Cómo nacen los volcanes?",
      "¿Por qué nos reímos?", "¿Cómo se hablan las plantas?",
      "¿Por qué a veces el tiempo parece volar?", "¿Cómo encuentran su camino las aves?",
    ],
    morning: ["¿Por qué cantan los pájaros al amanecer?", "¿Qué ocurre en el cerebro al despertar?", "¿Por qué nos despierta el café?"],
    day: ["¿Por qué cambian de tamaño las sombras?", "¿Cómo se sostienen las nubes en el cielo?", "¿Por qué sentimos hambre?"],
    evening: ["¿Por qué el cielo enrojece al atardecer?", "¿Cómo se preparan los animales para la noche?", "¿Por qué bostezamos por la noche?"],
    night: ["¿Por qué soñamos de noche?", "¿Cómo nacen y mueren las estrellas?", "¿Por qué cambia de forma la Luna?", "¿Qué vemos realmente en la Vía Láctea?"],
  },
  nl: {
    base: [
      "Waarom is de lucht blauw?", "Hoe maken bijen honing?",
      "Wat ligt er op de bodem van de oceanen?", "Waar komen vallende sterren vandaan?",
      "Waarom is de zee zout?", "Hoe werkt het geheugen?",
      "Waarom spinnen katten?", "Hoe ontstaan vulkanen?",
      "Waarom lachen we?", "Hoe praten planten met elkaar?",
      "Waarom lijkt tijd soms te vliegen?", "Hoe vinden vogels hun weg?",
    ],
    morning: ["Waarom zingen vogels bij zonsopgang?", "Wat gebeurt er in het brein als we wakker worden?", "Waarom maakt koffie ons wakker?"],
    day: ["Waarom veranderen schaduwen van grootte?", "Hoe blijven wolken in de lucht hangen?", "Waarom krijgen we honger?"],
    evening: ["Waarom kleurt de lucht rood bij zonsondergang?", "Hoe bereiden dieren zich voor op de nacht?", "Waarom geeuwen we 's avonds?"],
    night: ["Waarom dromen we 's nachts?", "Hoe worden sterren geboren en hoe sterven ze?", "Waarom verandert de Maan van vorm?", "Wat zien we echt in de Melkweg?"],
  },
};

const daypart = (h) => {
  if (h >= 5 && h < 11) return "morning";
  if (h >= 11 && h < 18) return "day";
  if (h >= 18 && h < 22) return "evening";
  return "night";
};

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Renvoie 5 étincelles : au moins 2 liées au moment de la journée, le reste tiré du fond commun.
export function pickSparks(lang = "fr", count = 5) {
  const pool = POOLS[lang] || POOLS.fr;
  const part = daypart(new Date().getHours());
  const timed = shuffle(pool[part] || []).slice(0, 2);
  const rest = shuffle(pool.base).slice(0, count - timed.length);
  return shuffle([...timed, ...rest]).slice(0, count);
}
